



































































import * as memberAPI from '@adobe/edex/frontend/api/member';
import Products from '@adobe/edex/frontend/components/common/products.vue';
import Subjects from '@adobe/edex/frontend/components/common/subjects.vue';
import AcademicLevels from '@adobe/edex/frontend/components/common/academic-levels.vue';

import { mapState } from 'vuex';
import { getParentSubjects } from '@adobe/edex/ui/shared/frontend/utils';

export default {
  props: ['profile'],
  components: {
    Products,
    Subjects,
    AcademicLevels,
  },
  data() {
    return {
      editMode: false,
      loading: false,
      formData: this.getFormData(),
    };
  },
  computed: {
    ...mapState('member', ['member']),
    showProducts() {
      return this.formData.products.length || this.editMode;
    },
    subjects() {
      return getParentSubjects(this.profile.interests.subjects);
    },
    showSubjects() {
      return this.subjects.length || this.editMode;
    },
    showAcademicLevels() {
      return this.formData.academicLevels.length || this.editMode;
    },
    showInterests() {
      return this.showProducts || this.showSubjects || this.showAcademicLevels;
    },
    canEdit() {
      return this.profile.id === this.member?.id;
    },
  },
  methods: {
    getFormData() {
      const { products, subjects, academicLevels } = this.profile.interests;
      return {
        products: products.map(({ id }) => id),
        subjects: subjects.map(({ id }) => id),
        academicLevels: academicLevels.map(({ id }) => id),
      };
    },
    onEdit() {
      this.editMode = !this.editMode;
    },
    onCancel() {
      this.formData = this.getFormData();
      this.editMode = false;
    },
    async onUpdate() {
      await this.updateInterests();
      this.editMode = false;
    },
    onChangeProducts(products) {
      this.formData.products = products;
    },
    onChangeSubjects(subjects) {
      this.formData.subjects = subjects;
    },
    onChangeAcademicLevels(academicLevels) {
      this.formData.academicLevels = academicLevels;
    },
    async updateInterests() {
      this.loading = true;
      const { status, data: profile } = await memberAPI.updateSelfInterests(
        this.formData
      );
      if (status === 200) {
        this.$emit('updated', profile);
      }
      this.loading = false;
    },
  },
};
